<template>
  <generic-modal :title="$t('load template')" ref="generic_modal">
    <div class="field">
      <generic-dropdown
        :title="$t('templates')"
        :placeholder="$t('select one')"
        :is_multiple="false"
        url="/accounting/account-template/catalog"
        name_field="name"
        value_field="template_id"
        @selected="select_template"
        ref="template_dropdown"
      />
    </div>
    <div class="container">
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("number") }}</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("target") }}</th>
            <th>{{ $t("type") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="account in accounts" :key="account.id">
            <td>
              <span v-for="d in account.depth"
                >&NonBreakingSpace;&NonBreakingSpace;&NonBreakingSpace;</span
              >{{ account.number }}
            </td>
            <td>{{ account.name }}</td>
            <td>{{ $t(account.target) }}</td>
            <td>{{ $t(account.type) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <pre>{{ meta }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-primary is-rounded" @click="apply_template">
        <span class="icon">
          <i class="fa fa-check"></i>
        </span>
        <span>{{ $t("apply") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "AccountingLoadTemplateModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: { settings: {} },
      error: "",
      accounts: [],
    };
  },
  computed: {},
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(parent_uuid) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    // save() {
    //   let v = this;
    //   let data = { ...v.meta };
    //   data.period_uuid = v.$route.params.period_uuid;
    //   if (!v.meta.uuid) {
    //     put("/accounting/account", data)
    //       .then(() => {
    //         v.$emit("success");
    //         v.$refs.generic_modal.close_modal();
    //       })
    //       .catch((error) => {
    //         v.error = generate_error_message_text(error);
    //       });
    //   } else
    //     post("/accounting/account", data)
    //       .then(() => {
    //         v.$emit("success");
    //         v.$refs.generic_modal.close_modal();
    //       })
    //       .catch((error) => {
    //         v.error = generate_error_message_text(error);
    //       });
    // },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
    select_template(template) {
      let v = this;
      v.meta = template.settings?.tree;
      v.accounts = v.calculate_accounts(v.meta);
      // console.log(template);
    },
    calculate_accounts(tree) {
      let v = this;
      let accounts = [];

      let calculate = (node, depth) => {
        node.depth = depth;
        accounts.push(node);
        if (node.children) {
          node.children.forEach((child) => {
            calculate(child, depth + 1);
          });
        }
      };

      tree.forEach((node) => {
        calculate(node, 0);
      });

      return accounts;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
